// extracted by mini-css-extract-plugin
export default {"form":"JobPlacesAtWork_form__zQRF-","submitHidden":"JobPlacesAtWork_submitHidden__6S0Jf","placeHolderShimmer":"JobPlacesAtWork_placeHolderShimmer__swc0S"};